import { render, staticRenderFns } from "./IncomeFutureChangesYN.vue?vue&type=template&id=5b18b41e"
import script from "./IncomeFutureChangesYN.vue?vue&type=script&lang=js"
export * from "./IncomeFutureChangesYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports